import { createFileRoute } from '@tanstack/react-router'
import IntegrationContainer from 'Integration/containers/IntegrationContainer'

import { Guard, adminClaims } from './-guard'

export const Route = createFileRoute('/integrations')({
    component: () => (
        <Guard claims={adminClaims}>
            <IntegrationContainer />
        </Guard>
    ),
})
